
import Home from './view/home'
import './App.css';
import { SnackbarProvider } from 'notistack';

function App() {
  return (
    <SnackbarProvider anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}>
      <div className="App">
        <Home />
      </div>
    </SnackbarProvider>

  );
}

export default App;
